import './text-area.sass';

export default {
	props: {
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		title: {
			type: String,
			default: '',
		},
		value: {
			required: false,
		},
		html: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			inputData: '',
			isFocused: false,
		};
	},

	template: `
		<label
			:class="[
				'text-area',
				{ 'text-area--disabled': disabled },
				{ 'text-area--filled': inputData && inputData.length > 0 },
				{ 'text-area--focused': isFocused },
				{ 'text-area--without-caption': !title }
			]"
		>
			<p 
				v-if="html" 
				v-html="inputData" 
				v-on="inputListeners" 
				:contenteditable="!disabled"
				:class="['contenteditable', { disabled: disabled }]"
			/>
			<textarea
				v-else
				@focus="isFocused = true"
				@blur="isFocused = false"
				class="text-area__area"
				v-on="inputListeners"
				v-model="inputData"
				:disabled="disabled"
			/>
			<p
				v-if="title"
				class="text-area__caption"
			>{{ title }}</p>
		</label>
	`,

	computed: {
		inputListeners: function () {
			const vm = this;
			return Object.assign({},
				this.$listeners,
				{
					input: function (event) {
						if (!vm.html) {
							vm.$emit('input', event.target.value || event.target.innerHTML);
						}
					},
					blur: function(event) {
						if (vm.html) {
							vm.$emit('input', event.target.innerHTML);
						}
					}
				}
			);
		}
	},

	mounted() {
		if(this.value != undefined) {
			this.inputData = this.value;
		}
	},

	watch: {
		value(val) {
			this.inputData = val;
		}
	},
};
